<template>
  <header class="app-header" :class="[
      {'app-header--active': showMobileMenu},
      `app-header--${headerTheme}`
    ]">
    <!-- Logo部分（PC和Mobile共用） -->
    <a :href="getPageUrl('/')" class="app-header__logo">
      <img :src="domainConfig?.['siteIcon']" class="app-header__logo-icon" alt="">
      <div class="app-header__logo-text">
        {{domainConfig?.['siteName']}}
      </div>
    </a>

    <!-- PC导航菜单 (只在桌面设备显示) -->
    <nav class="app-header__nav" v-if="deviceType === 'desktop' || deviceType === 'pc'">
      <a :href="getPageUrl('/')" class="app-header__nav-item"
        :class="{'app-header__nav-item--active': isRouteActive('/')}">

        <svg xmlns="http://www.w3.org/2000/svg" v-if="isRouteActive('/')"
          class="app-header__nav-icon" viewBox="0 0 14 14" fill="none">
          <path d="M8.4 10.5036H5.48333V14H8.4V10.5036Z" fill="var(--theme-primary)" />
          <path
            d="M13.9417 5.69615C13.9125 5.55047 13.825 5.43392 13.7083 5.34651L7.35 0.131113C7.14583 -0.0437045 6.825 -0.0437045 6.62083 0.131113L0.2625 5.34651C0.145833 5.43392 0.0583333 5.55047 0.0291666 5.66701V5.69615C0.0291666 5.75442 0 5.78356 0 5.84183V13.4173C0 13.7378 0.2625 14 0.583333 14H4.375V9.92092C4.375 9.60042 4.6375 9.33819 4.95833 9.33819H9.04167C9.3625 9.33819 9.625 9.60042 9.625 9.92092V14H13.4167C13.7375 14 14 13.7378 14 13.4173V5.84183C13.9417 5.78356 13.9417 5.75442 13.9417 5.69615Z"
            fill="var(--theme-primary)" />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" v-else class="app-header__nav-icon"
          viewBox="0 0 14 14" fill="none">
          <path d="M8.4 10.5036H5.48333V14H8.4V10.5036Z" fill="#1A4048" />
          <path
            d="M13.9417 5.69615C13.9125 5.55047 13.825 5.43392 13.7083 5.34651L7.35 0.131113C7.14583 -0.0437045 6.825 -0.0437045 6.62083 0.131113L0.2625 5.34651C0.145833 5.43392 0.0583333 5.55047 0.0291666 5.66701V5.69615C0.0291666 5.75442 0 5.78356 0 5.84183V13.4173C0 13.7378 0.2625 14 0.583333 14H4.375V9.92092C4.375 9.60042 4.6375 9.33819 4.95833 9.33819H9.04167C9.3625 9.33819 9.625 9.60042 9.625 9.92092V14H13.4167C13.7375 14 14 13.7378 14 13.4173V5.84183C13.9417 5.78356 13.9417 5.75442 13.9417 5.69615Z"
            fill="#1A4048" />
        </svg>

        <span>Home</span>
      </a>
      <a :href="getPageUrl('/loans')"
        class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/loans')}"
        @click="toggleDropdown('loans', $event)" ref="loansNavItem">
        <svg xmlns="http://www.w3.org/2000/svg" v-if="isRouteActive('/loans')"
          class="app-header__nav-icon" viewBox="0 0 14 14" fill="none">
          <path
            d="M7 0C3.13436 0 0 3.13426 0 7C0 10.8657 3.13426 14 7 14C10.8657 14 14 10.8657 14 7C14 3.13436 10.8657 0 7 0ZM7.58664 10.8817V12.1917H6.32488V10.9862C5.473 10.9461 4.64523 10.705 4.16301 10.4398L4.54075 8.95299C5.0712 9.24237 5.82661 9.51558 6.65441 9.51558C7.39373 9.51558 7.88406 9.2262 7.88406 8.728C7.88406 8.2458 7.4742 7.94042 6.52586 7.61894C5.16767 7.16081 4.23539 6.52591 4.23539 5.2883C4.23539 4.15513 5.02296 3.27912 6.38119 3.02196V1.81646H7.62692V2.93356C8.46277 2.95767 9.04138 3.15055 9.48341 3.35144L9.10567 4.78998C8.7842 4.63727 8.18946 4.33998 7.27333 4.33998C6.44558 4.33998 6.1803 4.70966 6.1803 5.06326C6.1803 5.47312 6.62228 5.75442 7.72339 6.14019C9.23428 6.67866 9.83705 7.37784 9.83705 8.53512C9.83705 9.66829 9.04947 10.6408 7.58681 10.8819L7.58664 10.8817Z"
            fill="var(--theme-primary)" />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" v-else class="app-header__nav-icon"
          viewBox="0 0 14 14" fill="none">
          <path
            d="M7 0C3.13436 0 0 3.13426 0 7C0 10.8657 3.13426 14 7 14C10.8657 14 14 10.8657 14 7C14 3.13436 10.8657 0 7 0ZM7.58664 10.8817V12.1917H6.32488V10.9862C5.473 10.9461 4.64523 10.705 4.16301 10.4398L4.54075 8.95299C5.0712 9.24237 5.82661 9.51558 6.65441 9.51558C7.39373 9.51558 7.88406 9.2262 7.88406 8.728C7.88406 8.2458 7.4742 7.94042 6.52586 7.61894C5.16767 7.16081 4.23539 6.52591 4.23539 5.2883C4.23539 4.15513 5.02296 3.27912 6.38119 3.02196V1.81646H7.62692V2.93356C8.46277 2.95767 9.04138 3.15055 9.48341 3.35144L9.10567 4.78998C8.7842 4.63727 8.18946 4.33998 7.27333 4.33998C6.44558 4.33998 6.1803 4.70966 6.1803 5.06326C6.1803 5.47312 6.62228 5.75442 7.72339 6.14019C9.23428 6.67866 9.83705 7.37784 9.83705 8.53512C9.83705 9.66829 9.04947 10.6408 7.58681 10.8819L7.58664 10.8817Z"
            fill="#1A4048" />
        </svg>
        <span>Auto Loans</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="app-header__nav-arrow"
          :class="{'app-header__nav-arrow--flip': activeDropdown === 'loans'}" viewBox="0 0 10 6"
          fill="none">
          <path
            d="M0.220916 0.258035C0.353094 0.121151 0.529714 0.040051 0.716435 0.0305019C0.903157 0.0209527 1.08664 0.0836373 1.2312 0.206368L1.28487 0.25706L5.01059 4.11357L8.71088 0.231714C8.84233 0.0939831 9.01857 0.0118081 9.20531 0.00117713C9.39205 -0.00945386 9.57592 0.0522195 9.72117 0.174197L9.77578 0.22489C9.90906 0.361041 9.9886 0.543709 9.99887 0.737275C10.0091 0.930842 9.94941 1.12143 9.83133 1.27188L9.78237 1.32745L5.54915 5.76789C5.41676 5.90681 5.23887 5.98928 5.05061 5.99903C4.86235 6.00877 4.6774 5.94508 4.53228 5.82053L4.48049 5.77179L0.220916 1.36059C0.150882 1.28816 0.0953235 1.20215 0.0574172 1.10747C0.0195109 1.0128 0 0.911313 0 0.808825C0 0.706337 0.0195109 0.604853 0.0574172 0.510177C0.0953235 0.415501 0.150882 0.32949 0.220916 0.25706V0.258035Z"
            :fill="isRouteActive('/loans') ? 'var(--theme-primary)' : '#0E192C'" />
        </svg>

        <!-- Loans下拉菜单 -->
        <div class="app-header__dropdown app-header__dropdown--loans"
          v-if="activeDropdown === 'loans'" ref="loansDropdown">
          <div class="app-header__dropdown-menu">
            <a :href="getPageUrl('/all-lenders')" class="app-header__dropdown-item">
              Auto Loan Lenders
            </a>
            <a :href="getPageUrl('/lenders-for-bad-credits')" class="app-header__dropdown-item">
              Best Auto Loan Rates For Bad Credits
            </a>
          </div>
        </div>
      </a>
      <a :href="getPageUrl('/calculators')"
        class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/calculators')}"
        @click="toggleDropdown('calculators', $event)" ref="calculatorsNavItem">
        <svg xmlns="http://www.w3.org/2000/svg" v-if="isRouteActive('/calculators')"
          class="app-header__nav-icon" viewBox="0 0 14 14" fill="none">
          <path
            d="M13.3654 0H8.16997C7.81303 0 7.53541 0.27762 7.53541 0.634561V5.86969C7.53541 6.22663 7.81303 6.50425 8.16997 6.50425H13.3654C13.7224 6.50425 14 6.22663 14 5.86969V0.634561C14 0.27762 13.7224 0 13.3654 0ZM12.0567 3.68839H9.43909C9.16147 3.68839 8.92351 3.49009 8.92351 3.25212C8.92351 3.01416 9.16147 2.81586 9.43909 2.81586H12.0567C12.3343 2.81586 12.5722 3.01416 12.5722 3.25212C12.5722 3.49009 12.3343 3.68839 12.0567 3.68839ZM5.83003 0H0.634561C0.27762 0 0 0.27762 0 0.634561V5.86969C0 6.22663 0.27762 6.50425 0.634561 6.50425H5.83003C6.18697 6.50425 6.46459 6.22663 6.46459 5.86969V0.634561C6.46459 0.27762 6.18697 0 5.83003 0ZM4.52125 3.68839H3.64873V4.56091C3.64873 4.83853 3.45043 5.07649 3.21246 5.07649C2.9745 5.07649 2.7762 4.83853 2.7762 4.56091V3.68839H1.90368C1.62606 3.68839 1.3881 3.49009 1.3881 3.25212C1.3881 3.01416 1.62606 2.81586 1.90368 2.81586H2.7762V1.94334C2.7762 1.66572 2.9745 1.42776 3.21246 1.42776C3.45043 1.42776 3.64873 1.66572 3.64873 1.94334V2.81586H4.52125C4.79887 2.81586 5.03683 3.01416 5.03683 3.25212C5.03683 3.49009 4.79887 3.68839 4.52125 3.68839ZM5.83003 7.49575H0.634561C0.27762 7.49575 0 7.77337 0 8.13031V13.3654C0 13.7224 0.27762 14 0.634561 14H5.83003C6.18697 14 6.46459 13.7224 6.46459 13.3654V8.13031C6.46459 7.77337 6.18697 7.49575 5.83003 7.49575ZM3.21246 8.92351C3.49009 8.92351 3.72805 9.16147 3.72805 9.43909C3.72805 9.71671 3.49009 9.95467 3.21246 9.95467C2.93484 9.95467 2.69688 9.71671 2.69688 9.43909C2.73654 9.16147 2.93484 8.92351 3.21246 8.92351ZM3.21246 12.5722C2.93484 12.5722 2.69688 12.3343 2.69688 12.0567C2.69688 11.779 2.93484 11.5411 3.21246 11.5411C3.49009 11.5411 3.72805 11.779 3.72805 12.0567C3.72805 12.3739 3.49009 12.5722 3.21246 12.5722ZM4.52125 11.1841H1.90368C1.62606 11.1841 1.3881 10.9858 1.3881 10.7479C1.3881 10.5099 1.62606 10.3116 1.90368 10.3116H4.52125C4.79887 10.3116 5.03683 10.5099 5.03683 10.7479C5.03683 10.9858 4.79887 11.1841 4.52125 11.1841ZM13.3654 7.49575H8.16997C7.81303 7.49575 7.53541 7.77337 7.53541 8.13031V13.3654C7.53541 13.7224 7.81303 14 8.16997 14H13.3654C13.7224 14 14 13.7224 14 13.3654V8.13031C14 7.77337 13.7224 7.49575 13.3654 7.49575ZM12.0567 12.017H9.43909C9.16147 12.017 8.92351 11.8187 8.92351 11.5807C8.92351 11.3428 9.16147 11.1445 9.43909 11.1445H12.0567C12.3343 11.1445 12.5722 11.3428 12.5722 11.5807C12.5722 11.8187 12.3343 12.017 12.0567 12.017ZM12.0567 10.3513H9.43909C9.16147 10.3513 8.92351 10.153 8.92351 9.91501C8.92351 9.67705 9.16147 9.47875 9.43909 9.47875H12.0567C12.3343 9.47875 12.5722 9.67705 12.5722 9.91501C12.5722 10.153 12.3343 10.3513 12.0567 10.3513Z"
            fill="var(--theme-primary)" />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" class="app-header__nav-icon" v-else
          viewBox="0 0 14 14" fill="none">
          <path
            d="M13.3654 0H8.16997C7.81303 0 7.53541 0.27762 7.53541 0.634561V5.86969C7.53541 6.22663 7.81303 6.50425 8.16997 6.50425H13.3654C13.7224 6.50425 14 6.22663 14 5.86969V0.634561C14 0.27762 13.7224 0 13.3654 0ZM12.0567 3.68839H9.43909C9.16147 3.68839 8.92351 3.49009 8.92351 3.25212C8.92351 3.01416 9.16147 2.81586 9.43909 2.81586H12.0567C12.3343 2.81586 12.5722 3.01416 12.5722 3.25212C12.5722 3.49009 12.3343 3.68839 12.0567 3.68839ZM5.83003 0H0.634561C0.27762 0 0 0.27762 0 0.634561V5.86969C0 6.22663 0.27762 6.50425 0.634561 6.50425H5.83003C6.18697 6.50425 6.46459 6.22663 6.46459 5.86969V0.634561C6.46459 0.27762 6.18697 0 5.83003 0ZM4.52125 3.68839H3.64873V4.56091C3.64873 4.83853 3.45043 5.07649 3.21246 5.07649C2.9745 5.07649 2.7762 4.83853 2.7762 4.56091V3.68839H1.90368C1.62606 3.68839 1.3881 3.49009 1.3881 3.25212C1.3881 3.01416 1.62606 2.81586 1.90368 2.81586H2.7762V1.94334C2.7762 1.66572 2.9745 1.42776 3.21246 1.42776C3.45043 1.42776 3.64873 1.66572 3.64873 1.94334V2.81586H4.52125C4.79887 2.81586 5.03683 3.01416 5.03683 3.25212C5.03683 3.49009 4.79887 3.68839 4.52125 3.68839ZM5.83003 7.49575H0.634561C0.27762 7.49575 0 7.77337 0 8.13031V13.3654C0 13.7224 0.27762 14 0.634561 14H5.83003C6.18697 14 6.46459 13.7224 6.46459 13.3654V8.13031C6.46459 7.77337 6.18697 7.49575 5.83003 7.49575ZM3.21246 8.92351C3.49009 8.92351 3.72805 9.16147 3.72805 9.43909C3.72805 9.71671 3.49009 9.95467 3.21246 9.95467C2.93484 9.95467 2.69688 9.71671 2.69688 9.43909C2.73654 9.16147 2.93484 8.92351 3.21246 8.92351ZM3.21246 12.5722C2.93484 12.5722 2.69688 12.3343 2.69688 12.0567C2.69688 11.779 2.93484 11.5411 3.21246 11.5411C3.49009 11.5411 3.72805 11.779 3.72805 12.0567C3.72805 12.3739 3.49009 12.5722 3.21246 12.5722ZM4.52125 11.1841H1.90368C1.62606 11.1841 1.3881 10.9858 1.3881 10.7479C1.3881 10.5099 1.62606 10.3116 1.90368 10.3116H4.52125C4.79887 10.3116 5.03683 10.5099 5.03683 10.7479C5.03683 10.9858 4.79887 11.1841 4.52125 11.1841ZM13.3654 7.49575H8.16997C7.81303 7.49575 7.53541 7.77337 7.53541 8.13031V13.3654C7.53541 13.7224 7.81303 14 8.16997 14H13.3654C13.7224 14 14 13.7224 14 13.3654V8.13031C14 7.77337 13.7224 7.49575 13.3654 7.49575ZM12.0567 12.017H9.43909C9.16147 12.017 8.92351 11.8187 8.92351 11.5807C8.92351 11.3428 9.16147 11.1445 9.43909 11.1445H12.0567C12.3343 11.1445 12.5722 11.3428 12.5722 11.5807C12.5722 11.8187 12.3343 12.017 12.0567 12.017ZM12.0567 10.3513H9.43909C9.16147 10.3513 8.92351 10.153 8.92351 9.91501C8.92351 9.67705 9.16147 9.47875 9.43909 9.47875H12.0567C12.3343 9.47875 12.5722 9.67705 12.5722 9.91501C12.5722 10.153 12.3343 10.3513 12.0567 10.3513Z"
            fill="#1A4048" />
        </svg>
        <span>Calculators</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="app-header__nav-arrow"
          :class="{'app-header__nav-arrow--flip': activeDropdown === 'calculators'}"
          viewBox="0 0 10 6" fill="none">
          <path
            d="M0.220916 0.258035C0.353094 0.121151 0.529714 0.040051 0.716435 0.0305019C0.903157 0.0209527 1.08664 0.0836373 1.2312 0.206368L1.28487 0.25706L5.01059 4.11357L8.71088 0.231714C8.84233 0.0939831 9.01857 0.0118081 9.20531 0.00117713C9.39205 -0.00945386 9.57592 0.0522195 9.72117 0.174197L9.77578 0.22489C9.90906 0.361041 9.9886 0.543709 9.99887 0.737275C10.0091 0.930842 9.94941 1.12143 9.83133 1.27188L9.78237 1.32745L5.54915 5.76789C5.41676 5.90681 5.23887 5.98928 5.05061 5.99903C4.86235 6.00877 4.6774 5.94508 4.53228 5.82053L4.48049 5.77179L0.220916 1.36059C0.150882 1.28816 0.0953235 1.20215 0.0574172 1.10747C0.0195109 1.0128 0 0.911313 0 0.808825C0 0.706337 0.0195109 0.604853 0.0574172 0.510177C0.0953235 0.415501 0.150882 0.32949 0.220916 0.25706V0.258035Z"
            :fill="isRouteActive('/calculators') ? 'var(--theme-primary)' : '#0E192C'" />
        </svg>

        <!-- Calculators下拉菜单 -->
        <div class="app-header__dropdown app-header__dropdown--calculators"
          v-if="activeDropdown === 'calculators'" ref="calculatorsDropdown">
          <div class="app-header__dropdown-menu">
            <a :href="getPageUrl('/auto-loan-calculator')" class="app-header__dropdown-item">
              Auto Loan Calculator
            </a>
            <a :href="getPageUrl('/auto-lease-calculator')" class="app-header__dropdown-item">
              Auto Lease Calculator
            </a>
            <a :href="getPageUrl('/total-car-cost-calculator')" class="app-header__dropdown-item">
              Total Car Cost Calculator
            </a>
          </div>
        </div>
      </a>
    </nav>

    <!-- Mobile菜单按钮 (只在移动设备显示) -->
    <div class="app-header__mobile-trigger" v-if="deviceType === 'mobile'"
      @click="toggleMobileMenu">
      <img :class="{'close': showMobileMenu}"
        :src="showMobileMenu ? require('@/assets/default/menu-icon-close.svg') : require('@/assets/default/menu-icon.svg')"
        alt="">
    </div>

    <!-- Mobile菜单 (显示/隐藏取决于showMobileMenu) -->
    <div class="app-header__mobile-menu-row" v-if="showMobileMenu && deviceType === 'mobile'">
      <div class="app-header__mobile-menu">
        <!-- Auto Loans 部分 -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-title">
            <img src="@/assets/default/loan-icon.svg" alt="">
            <span>Auto Loans</span>
          </div>
          <div class="app-header__mobile-menu-items">
            <a :href="getPageUrl('/all-lenders')" class="app-header__mobile-menu-item">
              <span>Auto Loan lenders</span>
              <img src="@/assets/default/arrow-right-small.svg" alt="">
            </a>
            <a :href="getPageUrl('/lenders-for-bad-credits')" class="app-header__mobile-menu-item">
              <span>Best Auto Loan Rates for Bad Credits</span>
              <img src="@/assets/default/arrow-right-small.svg" alt="">
            </a>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- Calculators 部分 -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-title">
            <img src="@/assets/default/calculators-icon.svg" alt="">
            <span>Calculators</span>
          </div>
          <div class="app-header__mobile-menu-items">
            <a :href="getPageUrl('/auto-loan-calculator')" class="app-header__mobile-menu-item">
              <span>Auto loan calculator</span>
              <img src="@/assets/default/arrow-right-small.svg" alt="">
            </a>
            <a :href="getPageUrl('/auto-lease-calculator')" class="app-header__mobile-menu-item">
              <span>Auto lease calculator</span>
              <img src="@/assets/default/arrow-right-small.svg" alt="">
            </a>
            <a :href="getPageUrl('/total-car-cost-calculator')"
              class="app-header__mobile-menu-item">
              <span>Total car cost calculator</span>
              <img src="@/assets/default/arrow-right-small.svg" alt="">
            </a>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- 底部链接 -->
        <div class="app-header__mobile-menu-links">
          <a :href="getPageUrl('/')" class="app-header__mobile-menu-link">
            <div>
              <img src="@/assets/default/home-icon.svg" alt="">
              <span>Home</span>
            </div>
            <img src="@/assets/default/arrow-right-small.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </a>
          <a :href="getPageUrl('/about-us')" class="app-header__mobile-menu-link">
            <div>
              <img src="@/assets/default/about-icon.svg" alt="">
              <span>About us</span>
            </div>
            <img src="@/assets/default/arrow-right-small.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </a>
          <a :href="getPageUrl('/terms-of-service')" class="app-header__mobile-menu-link">
            <div>
              <img src="@/assets/default/terms-icon.svg" alt="">
              <span>Terms of Services</span>
            </div>
            <img src="@/assets/default/arrow-right-small.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </a>
          <a :href="getPageUrl('/privacy-policy')" class="app-header__mobile-menu-link">
            <div>
              <img src="@/assets/default/privacy-icon.svg" alt="">
              <span>Privacy Policy</span>
            </div>
            <img src="@/assets/default/arrow-right-small.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </a>
          <a :href="getPageUrl('/disclaimer')" class="app-header__mobile-menu-link">
            <div>
              <img src="@/assets/default/disclaimer-icon.svg" alt="">
              <span>Disclaimer</span>
            </div>
            <img src="@/assets/default/arrow-right-small.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppHeader',
  components: {
  },
  props: {
    headerTheme: {
      type: String,
      default: 'light' // 可选值：'light'或'dark'
    },
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig',
      categories: 'categories',
      categoriesLoaded: 'categoriesLoaded',
      tvGenres: 'tvGenres',
      movieGenres: 'MovieGenres'
    }),
  },
  data () {
    return {
      showMobileMenu: false,
      activeDropdown: null,
      navItems: [
        { name: 'Home', link: '/' },
        { name: 'Auto Loans', link: '/loans' },
        { name: 'Calculators', link: '/calculators' },
      ],
      loansMenuItems: [
        { label: 'Auto Loan Lenders', value: '/loans/lenders' },
        { label: 'Best Auto Loan Rates For Bad Credits', value: '/lenders-for-bad-credits' },
      ],
      calculatorsMenuItems: [
        { label: 'Auto Loan Calculator', value: '/auto-loan-calculator' },
        { label: 'Auto Lease Calculator', value: '/calculators/lease' },
        { label: 'Total Car Cost Calculator', value: '/calculators/cost' },
      ],
    };
  },
  methods: {
    getPageUrl (path) {
      if (this.$route.params.channel) {
        return `/${this.$route.params.channel}${path}`;
      }
      return path;
    },
    toggleMobileMenu () {
      this.showMobileMenu = !this.showMobileMenu;

      // 如果打开菜单，禁止body滚动
      if (this.showMobileMenu) {
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100%';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.body.style.position = '';
        document.body.style.width = '';
      }
    },

    toggleDropdown (type, event) {
      if (this.activeDropdown === type) {
        // Dropdown is open. Allow navigation and close it.
        this.activeDropdown = null;
      } else {
        // Dropdown is closed or another one is open.
        // Prevent navigation and open/switch to this one.
        event.preventDefault();
        this.activeDropdown = type;
      }
    },

    // 判断当前路由是否激活
    isRouteActive (link) {
      // 获取不包含channel参数的当前路径
      let currentPath = this.$route.path;
      const channel = this.$route.params.channel;

      // 如果存在channel参数，移除channel部分以便正确比较
      if (channel && currentPath.startsWith(`/${channel}`)) {
        currentPath = currentPath.replace(`/${channel}`, '') || '/';
      }

      // 处理根路径特殊情况
      if (link === '/' && (currentPath === '/' || currentPath === '')) {
        return true;
      }

      // 处理首页特殊情况
      if (link === '/' && currentPath !== '/') {
        return false;
      }

      // 对于loans类别路径
      if (link === '/loans') {
        return (
          currentPath.startsWith('/loans') ||
          currentPath === '/all-lenders' ||
          currentPath === '/lenders-for-bad-credits' ||
          currentPath.startsWith('/lenders/')
        );
      }

      // 对于calculators类别路径
      if (link === '/calculators') {
        return (
          currentPath.startsWith('/calculators') ||
          currentPath === '/auto-loan-calculator' ||
          currentPath === '/auto-lease-calculator' ||
          currentPath === '/total-car-cost-calculator'
        );
      }

      // 其他页面直接比较路径
      return currentPath === link;
    },

    // 处理点击其他区域关闭下拉菜单
    handleClickOutside (event) {
      // 如果没有打开的下拉菜单，不处理
      if (!this.activeDropdown) return;

      // 检查点击事件的目标元素
      const target = event.target;

      // 检查点击是否在导航项上
      const isNavItemClick = target.closest('.app-header__nav-item--has-dropdown');

      // 如果点击在导航项上，不关闭（让toggleDropdown方法处理）
      if (isNavItemClick) return;

      // 检查点击是否在下拉菜单上
      const isDropdownClick = target.closest('.app-header__dropdown');

      // 如果点击不在下拉菜单上，关闭所有下拉菜单
      if (!isDropdownClick) {
        this.activeDropdown = null;
      }
    },
  },
  beforeDestroy () {
    // 确保在组件销毁时恢复body滚动
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.width = '';
    // 移除点击事件监听器
    document.removeEventListener('click', this.handleClickOutside);
  },
  mounted () {
    // 监听路由变化，关闭移动菜单
    this.$router.afterEach(() => {
      if (this.showMobileMenu) {
        this.showMobileMenu = false;
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.body.style.position = '';
        document.body.style.width = '';
      }

      // 关闭所有下拉菜单
      this.activeDropdown = null;
    });

    // 添加点击其他区域关闭下拉菜单的事件监听
    document.addEventListener('click', this.handleClickOutside);
  }
};
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.app-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	position: relative;
	width: 100%;
	box-sizing: border-box;
	background-color: #ffffff;
	z-index: 100;
	height: rem(56);

	a {
		text-decoration: none;
		display: flex;
	}

	// 主题样式
	&--light {
		color: #1a4048;
	}

	&--dark {
		color: #000000;
	}

	// Logo部分样式
	&__logo {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		cursor: pointer;

		&-icon {
			flex-shrink: 0;
			width: rem(28);
			height: rem(28);
			position: relative;
			overflow: visible;
		}

		&-text {
			color: var(--theme-primary);
			text-align: left;
			font-size: rem(20);
			line-height: rem(20);
			font-weight: 700;
			text-transform: uppercase;
			position: relative;
		}
	}

	// PC导航菜单样式
	&__nav {
		display: flex;
		flex-direction: row;
		gap: rem(52);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		height: 100%;

		&-item {
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			cursor: pointer;
			height: 100%;
			transition: opacity 0.3s;

			span {
				color: #1a4048;
				text-align: left;
				font-size: rem(16);
				line-height: rem(16);
				font-weight: 400;
				position: relative;
			}

			&:hover {
				span {
					color: rgba(#1a4048, 0.7);
				}
				.app-header__nav-icon {
					opacity: 0.7;
				}
			}

			&--active {
				position: relative;

				&:after {
					content: '';
					position: absolute;
					bottom: 0;
					left: 0;
					width: 100%;
					height: 2px;
					background-color: var(--theme-primary);
				}

				span {
					font-weight: 700;
					color: var(--theme-primary);
				}

				&:hover {
					span {
						color: var(--theme-primary);
					}
				}
			}

			&--has-dropdown {
				position: relative;
			}
		}

		&-icon {
			flex-shrink: 0;
			width: rem(20);
			height: rem(20);
			position: relative;
			overflow: visible;
		}

		&-arrow {
			flex-shrink: 0;
			width: rem(10);
			height: rem(6);
			position: relative;
			overflow: visible;
			transition: transform 0.3s ease, fill 0.3s ease;

			&--flip {
				transform: rotate(180deg);
			}
		}
	}

	// 下拉菜单样式
	&__dropdown {
		position: absolute;
		top: 100%;
		left: 0;
		transform: translateX(0);
		z-index: 1000;
		margin-top: rem(4);
		min-width: rem(200);

		&-menu {
			background: #ffffff;
			border-radius: rem(8);
			box-shadow: 0 rem(4) rem(16) rgba(0, 0, 0, 0.1);
			overflow: hidden;
		}

		&-item {
			padding: rem(12) rem(20);
			color: #1a4048;
			font-size: rem(14);
			line-height: rem(20);
			cursor: pointer;
			transition: background-color 0.3s;

			&:hover {
				background-color: var(--theme-primary-light);
			}
		}
	}

	// Mobile菜单按钮样式
	&__mobile-trigger {
		flex-shrink: 0;
		width: rem(28);
		height: rem(28);
		position: relative;
		overflow: visible;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: rem(28);
			height: rem(28);
		}

		.close {
			width: rem(16);
			height: rem(16);
		}
	}

	// Mobile菜单样式
	&__mobile-menu-row {
		position: fixed;
		top: rem(56); // 修改为与header高度一致
		height: calc(100vh - rem(56));
		left: 0;
		width: 100%;
		background: rgba(0, 0, 0, 0.5);
	}
	&__mobile-menu {
		width: 100%;
		background: #ffffff;
		border-radius: 0 0 rem(16) rem(16);
		display: flex;
		flex-direction: column;
		z-index: 999;

		&-section {
			padding: rem(16);
			display: flex;
			flex-direction: column;
			gap: rem(12);
		}

		&-title {
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			justify-content: flex-start;

			img {
				width: rem(16);
				height: rem(16);
			}

			span {
				color: #0e192c;
				font-size: rem(16);
				line-height: rem(16);
				font-weight: 700;
			}
		}

		&-items {
			display: flex;
			flex-direction: column;
			gap: rem(12);
		}

		&-item {
			border-radius: rem(12);
			border: rem(1) solid #0e192c;
			padding: rem(12) rem(16);
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			height: rem(44);
			position: relative;

			span {
				color: #0e192c;
				font-size: rem(13);
				line-height: rem(14);
				font-weight: 400;
			}

			img {
				width: rem(4);
				height: rem(8);
			}
		}

		&-divider {
			padding: 0 rem(16);

			&:after {
				content: '';
				display: block;
				border-top: 1px dashed rgba(14, 25, 44, 0.3);
				width: 100%;
			}
		}

		&-links {
			padding: rem(16);
			display: flex;
			flex-direction: column;
			gap: rem(8);
		}

		&-link {
			border-radius: rem(8);
			padding: rem(14) 0;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			height: rem(36);

			div {
				display: flex;
				flex-direction: row;
				gap: rem(8);
				align-items: center;
			}

			img {
				width: rem(20);
				height: rem(20);
			}

			span {
				color: #0e192c;
				font-size: rem(14);
				line-height: rem(14);
				font-weight: 400;
			}

			&-arrow {
				width: rem(4);
				height: rem(8);
			}
		}
	}

	&--active {
		// 当移动菜单展开时的样式
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.app-header {
		padding: 0 rem(120);

		&__nav-item {
			&--has-dropdown {
				.app-header__dropdown {
					left: 0;
					transform: translateX(0);
					min-width: rem(240);
				}
			}
		}
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.app-header {
		padding: rem(10) rem(16);
		background-color: #ffffff;
		border-bottom: 1px solid #e5e7eb;
		background: #fff;

		&--active {
			background: #ffffff !important;
		}
		&__logo {
			max-width: 80%;
		}

		&__logo-text {
			font-size: rem(18);
			line-height: rem(18);
			font-weight: 900;
			text-transform: uppercase;
			position: relative;
			overflow: hidden;
			display: -webkit-box;
			text-overflow: ellipsis;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}

		&__mobile-menu {
			background: #ffffff;
			border-radius: 0 0 rem(16) rem(16);

			&-section {
				padding: rem(16);
				display: flex;
				flex-direction: column;
				gap: rem(12);
			}

			&-title {
				display: flex;
				flex-direction: row;
				gap: rem(8);
				align-items: center;

				img {
					width: rem(16);
					height: rem(16);
				}

				span {
					color: #0e192c;
					font-size: rem(16);
					line-height: rem(16);
					font-weight: 700;
				}
			}

			&-items {
				display: flex;
				flex-direction: column;
				gap: rem(12);
			}

			&-item {
				border-radius: rem(12);
				border: rem(1) solid #0e192c;
				padding: rem(12) rem(16);
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				height: rem(44);
				position: relative;

				span {
					color: #0e192c;
					font-size: rem(13);
					line-height: rem(14);
					font-weight: 400;
				}

				img {
					width: rem(4);
					height: rem(8);
				}
			}

			&-divider {
				padding: 0 rem(16);

				&:after {
					content: '';
					display: block;
					border-top: 1px dashed rgba(14, 25, 44, 0.3);
					width: 100%;
				}
			}

			&-links {
				padding: rem(16);
				display: flex;
				flex-direction: column;
				gap: rem(8);
			}

			&-link {
				border-radius: rem(8);
				padding: rem(14) 0;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				height: rem(36);

				div {
					display: flex;
					flex-direction: row;
					gap: rem(8);
					align-items: center;
				}

				img {
					width: rem(20);
					height: rem(20);
				}

				span {
					color: #0e192c;
					font-size: rem(14);
					line-height: rem(14);
					font-weight: 400;
				}

				&-arrow {
					width: rem(4);
					height: rem(8);
				}
			}
		}
	}
}
</style>

